import { FC } from 'react'
import { useSelector } from 'react-redux'
import { currentStyleSelector } from '@chegg-wt/core/state/currentProject/selectors'
import { AppRoute } from '@chegg-wt/core/types/core'
import { useRoutesContext } from '@chegg-wt/core/components/RoutesContext'
import {
  BannerContainer,
  InfoBannerContent,
  InfoBannerHeading,
  InfoBannerHeadingContainer,
} from './styled'
import BannerImage from './components/BannerImage'
import BannerText from './components/BannerText'
import {
  CREATE_CITATION_TILE_ALT_TEXT,
  getBannerContainerData,
  infoBannerImages,
  infoBannerTextList,
  PLAGIARISM_TILE_ALT_TEXT,
  WRITING_ASSISTANT_TILE_ALT_TEXT,
} from './constants'

const InfoBanner: FC = () => {
  const { toSourceTypeSelection, toPlagiarism, toWritingAssistant } = useRoutesContext()
  const citationStyle = useSelector(currentStyleSelector)

  const getRedirect = (index: number): AppRoute => {
    switch (index) {
      case 0:
        return toWritingAssistant()
      case 1:
        return toSourceTypeSelection({ style: citationStyle })
      default:
        return toPlagiarism()
    }
  }

  const getImageAltText = (index: number): string => {
    switch (index) {
      case 0:
        return WRITING_ASSISTANT_TILE_ALT_TEXT
      case 1:
        return CREATE_CITATION_TILE_ALT_TEXT
      case 2:
        return PLAGIARISM_TILE_ALT_TEXT
      default:
        return ''
    }
  }

  return (
    <InfoBannerContent>
      <InfoBannerHeadingContainer>
        <InfoBannerHeading>
          Turn in <span>your best writing</span> with help from our tools
        </InfoBannerHeading>
      </InfoBannerHeadingContainer>

      {infoBannerTextList.map((bannerText, index) => {
        const { color, testId, isFlipped } = getBannerContainerData(index)

        const TextElement = (
          <BannerText {...{ ...bannerText, redirect: getRedirect(index) }} />
        )

        return (
          <BannerContainer
            key={testId}
            backgroundColor={color}
            data-test={testId}
            isFlipped={isFlipped}
          >
            {!isFlipped && TextElement}
            <BannerImage
              urlString={`${infoBannerImages[index]}`}
              altText={getImageAltText(index)}
            />
            {isFlipped && TextElement}
          </BannerContainer>
        )
      })}
    </InfoBannerContent>
  )
}

export default InfoBanner
